import { api } from '@/global/api'

export interface AnswerSimulationPayload {
  companyEmployees?: string
  companyCity?: string
  companyCnpj?: string
  companyName?: string
  responsibleName?: string
  responsiblePhone?: string
  responsibleEmail?: string
  findOutAlice?: string
}

export interface AnswerSimulationArgs {
  id: string
  payload: AnswerSimulationPayload
}

export const answerSimulation = async ({
  id,
  payload
}: AnswerSimulationArgs) => {
  await api.put(`/v2/simulation/${id}/answer`, payload)
}
